import {BadgeKind, BadgeSize} from './types';
import {
  ThemeColorName,
  ThemeSpacingName,
  ThemeTypographyName,
} from '../../theme';

export const BadgeStyletMap: {
  [key in BadgeSize]: {
    [key in BadgeKind]: {
      height: ThemeSpacingName;
      backgroundColor: ThemeColorName;
      color: ThemeColorName;
      borderColor?: ThemeColorName;
      borderWidth?: '1';
      borderStyle?: 'solid';
      typography?: ThemeTypographyName;
      paddingVertical?: ThemeSpacingName;
    };
  };
} = {
  Default: {
    Primary: {
      height: '24',
      backgroundColor: 'background_mono_primary',
      color: 'content_mono_primary',
      borderColor: 'border_mono_30',
      borderWidth: '1',
      borderStyle: 'solid',
      typography: 'inline_12_emphasis',
    },
    Grey: {
      height: '24',
      backgroundColor: 'background_mono_tertiary',
      color: 'content_mono_secondary',
      typography: 'inline_12_emphasis',
    },
    Negative: {
      height: '24',
      backgroundColor: 'background_negative_default',
      color: 'content_mono_inverse_primary',
      typography: 'inline_12_emphasis',
    },
    NegativeLight: {
      height: '24',
      backgroundColor: 'background_negative_light',
      color: 'content_negative_default',
      typography: 'inline_12_emphasis',
    },
    Positive: {
      height: '24',
      backgroundColor: 'background_positive_default',
      color: 'content_mono_inverse_primary',
      typography: 'inline_12_emphasis',
    },
    PositiveLight: {
      height: '24',
      backgroundColor: 'background_positive_light',
      color: 'content_positive_default',
      typography: 'inline_12_emphasis',
    },
  },
  Small: {
    Primary: {
      height: '18',
      backgroundColor: 'background_mono_primary',
      color: 'content_mono_primary',
      borderColor: 'border_mono_30',
      borderWidth: '1',
      borderStyle: 'solid',
      typography: 'inline_12_emphasis',
    },
    Grey: {
      height: '18',
      backgroundColor: 'background_mono_tertiary',
      color: 'content_mono_secondary',
      typography: 'inline_12_emphasis',
    },
    Negative: {
      height: '18',
      backgroundColor: 'background_negative_default',
      color: 'content_mono_inverse_primary',
      typography: 'inline_12_emphasis',
    },
    NegativeLight: {
      height: '18',
      backgroundColor: 'background_negative_light',
      color: 'content_negative_default',
      typography: 'inline_12_emphasis',
    },
    Positive: {
      height: '18',
      backgroundColor: 'background_positive_default',
      color: 'content_positive_default',
      typography: 'inline_12_emphasis',
    },
    PositiveLight: {
      height: '18',
      backgroundColor: 'background_positive_light',
      color: 'content_positive_default',
      typography: 'inline_12_emphasis',
    },
  },
};
